// extracted by mini-css-extract-plugin
module.exports = {"root":"EditListingDescriptionPanel_root__2CSln","form":"EditListingDescriptionPanel_form__2Dk7N","title":"EditListingDescriptionPanel_title__1-p3t"};